import { TypographyProps, Typography, useTheme } from '@mui/material';

export const DataGridStyledCellText = (props: TypographyProps) => {
  const { children, variant, sx, marginRight, ...rest } = props;

  const theme = useTheme();

  return (
    <Typography
      variant={variant ?? 'body2'}
      sx={{
        color: theme.palette.text.primary,
        marginRight: marginRight !== undefined ? marginRight : '26px',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};
